import type { ReactNode } from 'react';
import { STEP_COLUMN_WIDTH } from './stepLayout';

interface StepShellProps {
  title: string;
  subtitle: string;
  /**
   * Set by a step whose content has to point back at the heading, as `ModeChoiceStep`'s
   * radio group does. Left off, the heading is styling only and needs no id.
   */
  titleId?: string;
  children: ReactNode;
}

/**
 * The heading, the subtitle and the column they sit above, shared by every redesigned
 * creation step so the three agree on type and rhythm. They were drifting apart one step at
 * a time, each with its own heading size and column gap.
 */
export const StepShell = ({ title, subtitle, titleId, children }: StepShellProps) => (
  <div className="flex w-full flex-col items-center mt-4">
    <h2 id={titleId} className="mb-xs type-heading-lg text-foreground">
      {title}
    </h2>
    <p className="mb-2xl type-body-md text-foreground-alt">{subtitle}</p>

    <div className={`flex w-full ${STEP_COLUMN_WIDTH} flex-col gap-3xl mt-4`}>{children}</div>
  </div>
);
